import { useState, useEffect } from 'react';
import { useSubscriptionsStore } from '.';
import { useSchedulesStore } from '../schedules';

function useSubscriptions() {
    const subscriptionsStore = useSubscriptionsStore();
    const schedulesStore = useSchedulesStore();

    const [subscriptions, setSubscriptions] = useState([]);
    const [inactiveSubscriptions, setInactiveSubscriptions] = useState([]);
    const [connectedSchedules, setConnectedSchedules] = useState({});
    const [subscriptionDetails, setSubscriptionDetails] = useState({});
    const [availableSchedules, setAvailableSchedules] = useState({});
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        setSubscriptions(subscriptionsStore.subscriptions);
        setInactiveSubscriptions(subscriptionsStore.inactiveSubscriptions);
        setConnectedSchedules(subscriptionsStore.connectedSchedules);
        setSubscriptionDetails(subscriptionsStore.subscriptionDetails);
    }, [subscriptionsStore.observed.subscriptions]);

    useEffect(() => {
        setAvailableSchedules(subscriptionsStore.availableSchedules);
    }, [subscriptionsStore.observed.availableSchedules]);

    useEffect(() => {
        setIsLoading(subscriptionsStore.loadProgress.subscriptions);
    }, [subscriptionsStore.observed.loadProgress]);

    // ─── Actions — delegates to store, no logic here ────────────────────────

    function loadAvailableSchedules(subscriptionId) {
        subscriptionsStore.getAvailableSchedules(subscriptionId);
    }

    function unsubscribe(subscription) {
        subscriptionsStore.unsubscribe(subscription);
    }

    function addSchedule(subscriptionId, scheduleId) {
        const subscription = subscriptionsStore.subscriptions.find((s) => s.id === subscriptionId);
        const schedule = subscriptionsStore.availableSchedules[subscriptionId]?.find(
            (s) => s.scheduleId === scheduleId || s.id === scheduleId
        );
        if (subscription && schedule) {
            schedulesStore.addSchedule(subscription, schedule);
        }
    }

    function removeSchedule(subscriptionId, scheduleId) {
        const subscription = subscriptionsStore.subscriptions.find((s) => s.id === subscriptionId);
        const schedule = subscription?.subscribedSchedules?.find(
            (s) => s.scheduleId === scheduleId || s.id === scheduleId
        );
        if (subscription && schedule) {
            schedulesStore.deleteSchedule(subscription, schedule);
        }
    }

    function fetchActiveSubscriptions() {
        subscriptionsStore.getActiveSubscriptions();
    }

    function fetchInactiveSubscriptions() {
        subscriptionsStore.getInactiveSubscriptions();
    }

    return {
        subscriptions,
        inactiveSubscriptions,
        connectedSchedules,
        subscriptionDetails,
        availableSchedules,
        isLoading,
        unsubscribe,
        addSchedule,
        removeSchedule,
        loadAvailableSchedules,
        fetchActiveSubscriptions,
        fetchInactiveSubscriptions,
    };
}

export default useSubscriptions;
